import jwt_decode from "jwt-decode";
import { has } from "underscore";

let loadingCount = 0;


function Reducer(state, action) {
  if (Array.isArray(action)) {
    action.forEach((x) => {
      state = Reducer(state, x);
    });
    return state;
  } else {
    switch (action.type) {
      case "SET_LOGGED":
        let isLogged = false;
        let jwt = null;
        let profile = null;

        // Set the user data...
        if (action.payload != null && action.payload.jwt != null && action.payload.profile != null) {
          isLogged = true;
          jwt = action.payload.jwt;
          profile = action.payload.profile;

          localStorage.setItem("auth", jwt);
        } else {
          localStorage.removeItem("auth");
        }

        return {
          ...state,
          isLogged: isLogged,
          jwt: jwt,
          profile: profile,
        };

      case "SET_LOADING":
        loadingCount += (action.payload ? 1 : -1);
        let currentLoading = action.payload;

        if (loadingCount < 0)
          loadingCount = 0;

        if (!currentLoading && loadingCount > 0)
          currentLoading = true;

        return { ...state, loading: currentLoading };
      case "SET_TOAST":
        return { ...state, toast: action.payload };
      case "SET_CHANNEL_STATUS":
        return { ...state, channelStatus: action.payload };
      case "SET_CHANNEL_THUMBS":
        return { ...state, channelThumbnails: action.payload };
      case "ADD_TOAST":
        return { ...state, toast: [...state.toast, action.payload] };
      case "SET_READY":
        return { ...state, ready: action.payload };
      case "SET_CHURCH":
        if (action.payload && action.payload != "")
          localStorage.setItem("church", JSON.stringify(action.payload));
        else
          localStorage.removeItem("church");

        return { ...state, churchLoaded: true, church: action.payload, hasBranding: action.payload != null, hasPlan: action.payload?.planId };
      default:
        return state;
    }
  }
}

export default Reducer;
